/**
 * Subordinate object for the node element
 * Created by PeterWin on 29.05.2022.
 */
import { ChemObj } from "./ChemObj";

export abstract class ChemSubObj extends ChemObj {}
